export default __webpack_public_path__ + "static/media/epi5Vid.f5d4a037.jpg";